import { format, parse } from 'date-fns'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { Option, ValueEditor, ValueEditorProps } from 'react-querybuilder'
import Select, { MultiValue, SingleValue } from 'react-select'

type SelectOption = {
	value: string | number
	label: string
}

const dateFormat = 'yyyy-MM-dd'

export const CustomValueEditor = (props: ValueEditorProps) => {
	const multiSelectValueChange = (value: SingleValue<SelectOption> | MultiValue<SelectOption>) => {
		if (!value) {
			props.handleOnChange(null)
			return
		}

		if (Array.isArray(value)) {
			props.handleOnChange(value.map((option) => option.value).join(','))
			return
		}

		props.handleOnChange(value.value)
	}

	const parseMultiselectDefaultValue = (defaultValue: string | number | null, options: Array<SelectOption>) => {
		if (defaultValue === null) {
			return null
		}

		const parsedValues = defaultValue
			.toString()
			.split(',')
			.map((value) => parseInt(value, 10))

		return options.filter((option) => parsedValues.includes(option.value))
	}

	if (
		props.operator === 'null' ||
		props.operator === 'notNull' ||
		props.operator === 'less_than_today' ||
		props.operator === 'greater_than_today' ||
		props.operator === 'last_week' ||
		props.operator === 'last_month' ||
		props.operator === 'last_year' ||
		props.operator === 'last_quarter' ||
		props.operator === 'isEmpty' ||
		props.operator === 'isNotEmpty'
	) {
		return null
	}

	if (props.fieldData.inputType === 'date' && props.operator !== 'between' && props.operator !== 'notBetween') {
		return (
			<div>
				<DatePicker
					locale={document.documentElement.lang || 'en'}
					placeholderText={dateFormat}
					dateFormat={dateFormat}
					selected={!props.value ? null : parse(props.value, dateFormat, new Date())}
					onChange={(d: Date) => props.handleOnChange(d ? format(d, dateFormat) : null)}
				/>
			</div>
		)
	}

	if (props.fieldData.inputType === 'date' && (props.operator === 'between' || props.operator === 'notBetween')) {
		const [startDate, endDate] = props.value.split(',')
		return (
			<div>
				<DatePicker
					locale={document.documentElement.lang || 'en'}
					placeholderText={`${dateFormat},${dateFormat}`}
					selectsRange
					dateFormat={dateFormat}
					startDate={!startDate ? null : parse(startDate, dateFormat, new Date())}
					endDate={!endDate ? null : parse(endDate, dateFormat, new Date())}
					onChange={(update: [Date, Date]) => {
						const [s, e] = update
						props.handleOnChange([!s ? '' : format(s, dateFormat), !e ? '' : format(e, dateFormat)].join(','))
					}}
				/>
			</div>
		)
	}

	if (props.fieldData.inputType === 'multiselect') {
		const selectOptions = props.values.map((value: Option): SelectOption => {
			return { value: value.name, label: value.label }
		})

		return (
			<Select
				closeMenuOnSelect={false}
				isMulti={props.operator === 'in' || props.operator === 'notIn'}
				options={selectOptions}
				defaultValue={parseMultiselectDefaultValue(props.value, selectOptions)}
				onChange={multiSelectValueChange}
			/>
		)
	}

	return <ValueEditor {...props} />
}
